import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { ESTADOS_GLOBALES_MAP } from 'utils/estadosGlobales';

export const baseURI = 'recaudacion/motivos-de-cancelacion-pae/';

/**
 * GET Motivos de Cancelación
 * param {object} params
 * @returns {Promise<object>}
 */
export const getMotivosDeCancelacion = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Motivo de Cancelación
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getMotivoDeCancelacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Motivo de Cancelación
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postMotivoDeCancelacion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Motivo de Cancelación
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMotivoDeCancelacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Motivo de Cancelación
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteMotivoDeCancelacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, {
      estados_globales: ESTADOS_GLOBALES_MAP.CANCELADO,
    });
    onSuccess(response, 'Cancelado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
